import {createContext} from "react";

const SearchFiltersContext = createContext(undefined);
export default SearchFiltersContext;